import { isProd, isTest } from '@w/fe-utils'
import { makeMwTokenPayload, _typedLocalStorage, TOKEN_KEY } from '../local-storage/local-storage'
import { conf } from '../fe-inv-conf'

export function animationTime(time: number) {
  return isTest ? 0 : time
}

export function publicUrl(url: string) {
  if (isProd && !conf.STORYBOOK) {
    let base = conf.INVOICING_MICRO_FRONTEND_URL
    if (base.endsWith('/')) base = base.slice(0, -1)
    return `${base}${url}`
  }
  return url
}

function jwtEncode(payload: unknown): string {
  const header = {
    alg: 'none', // Indicate no signature
    typ: 'JWT',
  }

  const headerBase64 = btoa(JSON.stringify(header))
  const payloadBase64 = btoa(JSON.stringify(payload))

  return `${headerBase64}.${payloadBase64}.` // No signature
}

export function readAndSaveToken() {
  const userInput = window.prompt('Please enter your token:', '')
  if (userInput) {
    _typedLocalStorage.setItem(TOKEN_KEY, userInput)
  } else {
    _typedLocalStorage.setItem(TOKEN_KEY, jwtEncode(makeMwTokenPayload()))
  }
}
